import FeatureCard from './components/FeatureCard';
import styles from './AdminLandingPage.module.scss';
import { BillsPaymentIcon, EnergyManagementIcon, ServiceRequestIcon, SolarMarketplaceIcon } from '../../../assets/icons';
import { ApplicationRoutes } from '../../../routes';
import LandingUserInfoDropdown from '../../../common/components/user-info-dropdown/LandingUserInfoDropDown';
import { useTenant } from '../../../tenant/branding/useTenant';
import { TenantLogo } from '../../../tenant/branding/TenantLogo';


const AdminLandingPage = () => {
  const { logo, name } = useTenant();
  const features = [
    {
      icon:  <SolarMarketplaceIcon />, 
      title: <h1 className='title'>Solar<br/>Marketplace</h1>,
      description: "Realtime network tracking, outage reports, and energy supply visibility for efficient grid management.",
      image: '../../../../images/solar-place-module.png',
      type: 'solar',
      link: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.DASHBOARD}`,
    },
    {
      icon: <BillsPaymentIcon/>,
      title: <h1 className='title'>Bills<br/>Payment</h1>,
      description: "Simplify revenue management, customer interactions, and billing with our comprehensive commercial module.",
      image: '../../../../images/bill-payment-module.png',
      type: 'bills',
      link: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.ADMIN_BILLS}/${ApplicationRoutes.DASHBOARD}`,
    },
    {
      icon: <EnergyManagementIcon/>,
      title: <h1 className='title'>Energy<br/>Management</h1>,
      description: "Aggregates and analyzes meter data for asset and customer insights.",
      image: '../../../../images/energy-management-module.png',
      type: 'energy',
      link: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.ADMIN_LANDING}`,
    },
    {
      icon: <ServiceRequestIcon/>,
      title: <h1 className='title'>Service<br/>Request</h1>,
      description: "Streamlined fault logging, real-time tracking & optimized asset maintenance.",
      image: '../../../../images/service-request-module.png',
      type: 'request',
      link: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.ADMIN_LANDING}`,
    }
  ];

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <TenantLogo logo={logo} alt={name} className={styles.logo} />
          <h3 className={styles.headerName}>{name}</h3>
        </div>
       <LandingUserInfoDropdown />
        {/* <div className={styles.userContainer}>
          <div className={styles.avatar}>
            F
          </div>
          <button className={styles.dropdownButton}>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path 
                fillRule="evenodd" 
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
                clipRule="evenodd" 
              />
            </svg>
          </button>
        </div> */}
      </div>
      
     
      <h1 className={styles.heading}>
          What would you like to do today?
      </h1>

      {/* Main content */}
      <div className={styles.main}>
        <div className={styles.grid}>
          {features.map((feature, index) => (
            <FeatureCard 
              type={feature.type}
              link={feature.link}
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              image={feature.image}
            />
          ))}
        </div>
      </div>
      
      {/* Footer */}
      <div className={styles.footer}>
        Powered by <span className={styles.poweredBy}>Beacon Power Services</span>
      </div>
    </div>
  );
};

export default AdminLandingPage;